import * as angular from "angular";
import { PermissionCheck } from "../../../shared/permission";
import { Group } from "../../../models/group.model";

let GanttLaneInfoComponent = {
    selector: "ganttLaneInfo",
    templateUrl:
        "/angular/components/planner/gantt-chart/gantt-lane-info.component.html",
    bindings: {
        lane: "<",
        list: "<",
        isGrouped: "<",
        hasPermission: "<",
        onLaneClick: "&",
        onListClick: "&",
        onEditList: "&",
        onViewList: "&",
        onDeleteList: "&",
        onEditAssignment: "&",
        onDeleteAssignment: "&",
        onApproveList: "&",
    },
    controller: class GanttLaneInfoController {
        public lane: any;
        public list: any;
        public isGrouped: boolean;
        public hasPermission: boolean;
        public assignees: any[];
        public permissionProvider: PermissionCheck;
        private $window: any;

        // Callback functions
        public onLaneClick: () => void;
        public onListClick: () => void;
        public onEditList: () => void;
        public onViewList: () => void;
        public onDeleteList: () => void;
        public onEditAssignment: () => void;
        public onDeleteAssignment: () => void;
        public onApproveList: () => void;

        private readonly modelsUtils: any;

        constructor(
            ModelsUtils: any,
            PermissionCheck: PermissionCheck,
            $window: any
        ) {
            this.modelsUtils = ModelsUtils;
            this.permissionProvider = PermissionCheck;
            this.$window = $window;
        }

        $onInit() {
            this.isGrouped = this.isGrouped || false;
            this.hasPermission = this.hasPermission || false;
            let teams = this.lane.assignment.assignedTeams.map((team: any) => {
                return { ...this.modelsUtils.team(team), type: "team" };
            });
            let users = this.lane.assignment.assignedUsers.map((user: any) => {
                return {
                    ...this.modelsUtils.user(user),
                    type: "user",
                };
            });
            this.assignees = users.concat(teams);
        }

        // Event handlers
        public handleClick(): void {
            if (!this.hasPermission) return;
            if (this.isGrouped && this.onListClick) {
                this.onListClick();
            } else if (!this.isGrouped && this.onLaneClick) {
                this.onLaneClick();
            }
        }

        public getTooltipText(): string {
            return this.lane.assignment.originalAssignment.assigneesString();
        }
        public handleViewTurf(group: Group): void {
            this.$window.location = `/#/map?gid=${group.gid}`;
        }

        public handleEditList(): void {
            if (this.onEditList) {
                this.onEditList();
            }
        }

        public handleViewList(): void {
            if (this.onViewList) {
                this.onViewList();
            }
        }
        public handleDeleteList(): void {
            if (this.onDeleteList) {
                this.onDeleteList();
            }
        }

        public handleEditAssignment(): void {
            if (this.onEditAssignment) {
                this.onEditAssignment();
            }
        }

        public handleDeleteAssignment(): void {
            if (this.onDeleteAssignment) {
                this.onDeleteAssignment();
            }
        }
        public handleApproveList(): void {
            if (this.onApproveList) {
                this.onApproveList();
            }
        }
    },
};

angular
    .module("planner")
    .component(GanttLaneInfoComponent.selector, GanttLaneInfoComponent);
